/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Deploy a prebuilt Docker image as-is.
 */
export type DeploymentSourceImage = {
  /**
   * Deprecated. Use `oci.image` in v3 instead. This field is the full image reference to deploy as-is. Qualify the version with a tag (ghcr.io/acme/api:v1.2.3) or a digest (ghcr.io/acme/api@sha256:...). Without either, the registry serves the latest tag.
   *
   * @deprecated field: This will be removed in a future release, please migrate away from it as soon as possible.
   */
  dockerImage: string;
};

/** @internal */
export type DeploymentSourceImage$Outbound = {
  dockerImage: string;
};

/** @internal */
export const DeploymentSourceImage$outboundSchema: z.ZodType<
  DeploymentSourceImage$Outbound,
  z.ZodTypeDef,
  DeploymentSourceImage
> = z.object({
  dockerImage: z.string(),
});

export function deploymentSourceImageToJSON(
  deploymentSourceImage: DeploymentSourceImage,
): string {
  return JSON.stringify(
    DeploymentSourceImage$outboundSchema.parse(deploymentSourceImage),
  );
}
